import React from 'react';
import companyContact from '../data/companyContact.json';

// React escapes the source text. Links are taken only from the supplied document, never CMS HTML.
function linkedText(text, links) {
  const pieces = [];
  let remaining = text;
  while (remaining) {
    let match;
    for (const link of links) {
      const index = remaining.indexOf(link.label);
      if (link.label && index >= 0 && /^(https:\/\/|mailto:)/.test(link.url) && (!match || index < match.index)) {
        match = { ...link, index };
      }
    }
    if (!match) { pieces.push(remaining); break; }
    pieces.push(remaining.slice(0, match.index));
    pieces.push(<a key={pieces.length} href={match.url} target="_blank" rel="noopener noreferrer">{match.label}</a>);
    remaining = remaining.slice(match.index + match.label.length);
  }
  return pieces;
}

export default function LegalDocument({ document, documentKey }) {
  const elements = [];
  const blocks = document.blocks;
  for (let i = 0; i < blocks.length; i += 1) {
    const block = blocks[i];
    const renderText = (item) => linkedText(item.text, document.links || []);
    if (block.type === 'bullet' || block.type === 'numbered') {
      const Tag = block.type === 'bullet' ? 'ul' : 'ol';
      const start = i;
      const items = [];
      while (i < blocks.length && blocks[i].type === block.type) {
        items.push(<li key={i} data-legal-block={`${documentKey}-${i}`}>{renderText(blocks[i])}</li>);
        i += 1;
      }
      i -= 1;
      elements.push(<Tag key={start}>{items}</Tag>);
    } else {
      const Tag = { title: 'h2', heading: 'h3', subheading: 'h4', paragraph: 'p' }[block.type] || 'p';
      elements.push(<Tag key={i} data-legal-block={`${documentKey}-${i}`}>{renderText(block)}</Tag>);
    }
  }
  // Legal wording stays English even when the surrounding interface is localized.
  return <article lang="en" className="legal-document" tabIndex={0} aria-label={blocks[0].text}>
    {elements}
    <address className="company-mailing-address" aria-label="Current MedEffects mailing address">
      <strong>Current mailing address</strong><br />
      {companyContact.companyName}<br />
      {companyContact.addressLines.map((line, index) => <React.Fragment key={line}>{line}{index < companyContact.addressLines.length - 1 && <br />}</React.Fragment>)}
    </address>
  </article>;
}
